import React from 'react';
import { get } from 'lodash-es';
import { defineMessages } from 'react-intl';

import { BulkActions } from '../../../../enums/bulk-actions';
import ShipmentEmailTemplateDropdown from './shipment-email-template-dropdown';
import DeliveryEmailTemplateDropdown from './delivery-email-template-dropdown';

import style from '../bulk-actions.module.less';

const messages = defineMessages({
  needsOne: {
    description: 'bulkDimensionInput.needsOne',
    defaultMessage: 'Fill out at least 1 field to continue',
    id: 'Rj9s72',
  },
});

const getPropertiesFromModel = (model) => {
  const templates = get(model, 'templates');
  const shipmentEmailTemplateId = get(templates, 'shipmentEmailTemplateId');
  const deliveryEmailTemplateId = get(templates, 'deliveryEmailTemplateId');
  return { templates, shipmentEmailTemplateId, deliveryEmailTemplateId };
};

export default {
  id: BulkActions.emailTemplate.name,
  render: (onChange, model) => {
    const { templates, shipmentEmailTemplateId, deliveryEmailTemplateId } = getPropertiesFromModel(model);
    return (
      <div className={style['dropdown-list']}>
        <ShipmentEmailTemplateDropdown
          dropdownMenuShouldHaveWidthOfButton
          onItemSelected={(newShipmentEmailTemplateId) => {
            onChange({
              ...model,
              templates: {
                ...templates,
                shipmentEmailTemplateId: newShipmentEmailTemplateId,
              },
            });
          }}
          selectedShipmentEmailTemplateId={shipmentEmailTemplateId}
        />
        <DeliveryEmailTemplateDropdown
          dropdownMenuShouldHaveWidthOfButton
          onItemSelected={(newDeliveryEmailTemplateId) => {
            onChange({
              ...model,
              templates: {
                ...templates,
                deliveryEmailTemplateId: newDeliveryEmailTemplateId,
              },
            });
          }}
          selectedDeliveryEmailTemplateId={deliveryEmailTemplateId}
        />
      </div>
    );
  },
  getErrorsFromModel: (model) => {
    const { shipmentEmailTemplateId, deliveryEmailTemplateId } = getPropertiesFromModel(model);
    if (!shipmentEmailTemplateId && !deliveryEmailTemplateId) {
      return [
        {
          code: 'bulk:needs-one-email-template',
          defaultMessage: messages.needsOne,
        },
      ];
    }
  },
};
